import { handleActions } from 'redux-actions';
import {
  fetchCuponsRequest,
  fetchCuponsSuccess,
  getCupomRequest,
  getCupomSuccess,
  createCupomRequest,
  createCupomSuccess,
  updateCupomRequest,
  updateCupomSuccess,
  newCupomRequest,
} from '../actions/cuponsActions';

const defaultState = {
  cupons: [],
  totalPages: 0,
  cupom: {},
  count: 0,
  isFetching: false,
  error: null,
};

export default handleActions(
  {
    [fetchCuponsRequest](state) {
      return {
        ...state,
        isFetching: true,
        error: null,
      };
    },
    [fetchCuponsSuccess](state, { payload }) {
      return {
        ...state,
        cupons: payload.docs,
        totalItems: payload.totalDocs,
        totalPages: payload.totalPages,
        isFetching: false,
        error: null,
      };
    },
    [getCupomRequest](state) {
      return {
        ...state,
        cupom: {},
        isFetching: true,
        error: null,
      };
    },
    [getCupomSuccess](state, { payload }) {
      return {
        ...state,
        cupom: payload,
        isFetching: false,
        error: null,
      };
    },
    [createCupomRequest](state) {
      return {
        ...state,
        isFetching: true,
        error: null,
      };
    },
    [createCupomSuccess](state, { payload }) {
      return {
        ...state,
        cupom: payload,
        isFetching: false,
        error: null,
      };
    },
    [updateCupomRequest](state) {
      return {
        ...state,
        isFetching: true,
        error: null,
      };
    },
    [updateCupomSuccess](state, { payload }) {
      return {
        ...state,
        cupom: payload,
        isFetching: false,
        error: null,
      };
    },
    [newCupomRequest](state, { payload }) {
      return {
        ...state,
        cupom: '',
        isFetching: false,
        error: payload,
      };
    },
  },
  defaultState
);
